import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
Vue.use(Vuex)
const mutations = {
  updateSelectIndex(state, newIndex) {
    state.selectIndex = newIndex;
  },
  updatecarSize(state, result) {
    // console.log(result,'result');
    state.cartSize = result;
    // console.log(state.cartSize,'result');
  }
}
const modulesFiles = require.context('./modules', true, /\.js$/)

const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  
  return modules
}, {})
const store = new Vuex.Store({
  modules,
  getters,
  mutations,
  state: {
    selectIndex: '',
    cartSize:0,
  },
})

export default store